import { ChangeDetectionStrategy, Component, OnInit, Input, OnDestroy } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ProjectAlert } from 'projects/app-misc/src/app/modules/alert/data/alert';
import { AlertService } from 'projects/app-misc/src/app/modules/alert/data/alert.service';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-alerts-panel',
  templateUrl: './alerts-panel.component.html',
  styleUrls: ['./alerts-panel.component.scss']
})
@RxJSUnsubscribe
export class AlertsPanelComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
  @Input()
  alertsOP: OverlayPanel

  alertsList: ProjectAlert[] = [];

  alrtsWsSub: Subscription;

  constructor(
    protected alertService: AlertService,
    protected wsService: WsService) {
  }

  ngOnInit(): void {
    this.getAlerts();

    this.wsSubToAlerts()
  }

  wsSubToAlerts() {
    this.alrtsWsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<ProjectAlert>>('/topic/update/model.notification.alert.ProjectAlert', this)
      .pipe(
        debounceTime(2000)
      )
      .subscribe(() => {
        this.getAlerts();
      })
  }


  getAlerts() {
    this.alertService.getActiveAlerts().subscribe(alerts => {
      this.alertsList = alerts.content;
    })
  }

  ngOnDestroy() {
    if (this.alrtsWsSub) {
      this.alrtsWsSub.unsubscribe()
      this.alrtsWsSub = null;
    }
  }

  openNFPage() {
    this.alertsOP.hide()
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
